// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3PPGD","author":"Table_author__1Qg5r","authorImage":"Table_authorImage__CuPqG","unreadRow":"Table_unreadRow__14bzN"};